<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-select
          v-model="localSelected"
          :items="filtered"
          item-text="label"
          item-value="value"
          :menu-props="{ maxHeight: '400' }"
          :clearable="true"
          :chips="true"
          :small-chips="true"
          :hide-details="true"
          dense
          deletable-chips
          multiple
        >
          <template v-slot:prepend-item>
            <v-text-field
              class="pl-5 pr-5"
              label="Search"
              v-model="search"
            ></v-text-field>
          </template>
        </v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashIsEqual from "lodash/isEqual";
import {
  getPreference,
  savePreference,
} from "@/services/isosTravelTracker/travelTracker.service";
import { mapGetters } from "vuex";
import { MODULE_PREFIX_MAP } from "@/store";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "TravelTrackerTravelTypeSelector",
  components: {},
  props: {
    selected: {
      type: Array,
    },
  },
  data() {
    return {
      options: [
        { value: "airplane", label: "Airplane" },
        { value: "hotel", label: "Hotel" },
        { value: "car", label: "Car" },
        { value: "train", label: "Train" },
      ],
      localSelected: [],
      search: "",
    };
  },
  async mounted() {
    this.localSelected =
      getPreference(this.$store, [], "travelTypes", "travelTracker") ??
      this.localSelected;
  },
  computed: {
    ...mapGetters({
      resetMapIcons: MODULE_PREFIX_MAP + "resetMapIcons",
    }),
    filtered() {
      return this.options
        .filter((item) => {
          return (
            item.label.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            this.search === ""
          );
        })
        .sort(function (a, b) {
          var nameA = a.label.toLowerCase();
          var nameB = b.label.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
    },
  },
  methods: {
    async resetSelection() {
      this.localSelected = [];
      savePreference(
        this.$store,
        this.localSelected,
        "travelTypes",
        "travelTracker"
      );
      this.$emit(EMITTED_ACTIONS.CHANGE, this.localSelected);
    },
  },
  watch: {
    selected: {
      handler(newVal, oldVal) {
        if (lodashIsEqual(newVal, oldVal)) {
          this.localSelected = this.selected;
        }
      },
    },
    localSelected: {
      handler() {
        savePreference(
          this.$store,
          this.localSelected,
          "travelTypes",
          "travelTracker"
        );
        this.$emit(EMITTED_ACTIONS.CHANGE, this.localSelected);
      },
    },
    resetMapIcons: {
      handler(newValue, oldValue) {
        if (oldValue !== newValue) {
          this.resetSelection();
        }
      },
    },
  },
};
</script>

<style scoped>
.hyp-input-checkbox {
  margin-top: 0;
}
</style>
